<template>
  <el-dialog :visible.sync="visible"
             title="查看员工"
             width="70%"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-table
      v-loading="dataListLoading"
      :data="dataList"
      border
      style="width: 100%; max-width: 100%;">
      <el-table-column type="index" label="序号" header-align="center" align="center" width="50"></el-table-column>
      <el-table-column prop="code" label="员工编号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="name" label="姓名" header-align="center" align="center"></el-table-column>
      <el-table-column prop="orgName" label="部门" header-align="center" align="center"></el-table-column>
      <el-table-column prop="userName" label="账号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="getDataList">
    </el-pagination>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      visible: false,
      postId: '',
      dataListLoading: false,
      dataList: [],
      page: 1,
      limit: 10,
      total: 0
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.getDataList(1)
      })
    },
    pageSizeChangeHandle (val) {
      this.limit = val
      this.getDataList(1)
    },
    // 获取岗位员工列表
    getDataList (page = this.page) {
      this.page = page
      if (this.dataListLoading) {
        return false
      }
      this.dataListLoading = true
      this.$http.post(`/front/consumer/custorg/postEmployees`, {
        postId: this.postId,
        page: page,
        limit: this.limit
      })
        .then(({ data: res }) => {
          this.dataListLoading = false
          if (res.code !== 0) {
            return false
          }
          this.dataList = res.data.data || []
          this.total = res.data.count
        }).catch(() => {
          this.dataListLoading = false
        })
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
